import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import StereoSelect from '@magalu/stereo-ui/atoms/Select';
export var Select = styled(StereoSelect).attrs(function () {
  return {
    mr: 2
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 300px;\n"])));